import { Currency } from '../../../constants';

export type GetPageMetaRequest = {
  pathname: string;
  currency?: Currency;
};

export type PageMeta = {
  postId: number;
  title: string;
  description: string;
  type: string;
  url: string;
  robots?: string;
  locale?: string;
  siteName?: string;
  image?: string;
  seoSchema?: Record<string, unknown>;
};

export type GetPageMetaResponse = PageMeta;

export type GetCollectionDetailRequest = {
  slug: string;
};

export type CollectionTerm = {
  termId: number;
  name: string;
  slug: string;
  description?: string;
};

export type CollectionIntroduction = {
  bannerImageUrl: string;
  body: string;
};

export type GetCollectionDetailResponse = {
  term: CollectionTerm;
  introduction?: CollectionIntroduction;
};
